export default __webpack_public_path__ + "static/media/info.4c4ab48f.svg";